import type React from "react";
import { twJoin } from "tailwind-merge";

import ImgNobiLogo from "@/assets/images/nobi.png";

interface NobiGlobProps {
  isDisabled?: boolean;
  size?: "sm" | "md" | "lg";
}

export function NobiGlob({ size = "md", isDisabled }: NobiGlobProps): React.ReactNode {
  return (
    <img
      src={ImgNobiLogo}
      alt="AI Logo"
      className={twJoin(
        "rounded-full transition-opacity",
        isDisabled ? "opacity-60" : undefined,
        size === "sm" && "size-icon-inline",
        size === "md" && "size-icon-control",
        size === "lg" && "size-control-md",
      )}
    />
  );
}
